document.addEventListener("DOMContentLoaded", e => {
  const isCart = window.location.pathname === '/cart';
  if(isCart) {
    const cartNoteBSS = document.querySelector(".bss-cart-note");
    if(cartNoteBSS) cartNoteBSS.value = '';
  }

  const inputSearch = document.querySelector(`[action="/search"] .input-group__field.search__input`);
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });
})